export default function install(app) {
  try {
    app.config.globalProperties.$isMobile = window.matchMedia('(max-width: 768px)').matches;
  } catch {
    // Necessary for ssr
    app.config.globalProperties.$isMobile = true;
  }
}
